<template lang="pug">
v-expansion-panel.outlined.mt-2()
  v-expansion-panel-header(@click="open = true")
    v-row.pa-0.ma-0
      span.mt-2 {{ keyWord.name }}
      v-spacer
      v-tooltip(bottom) Удалить ключевое слово
        template(#activator="{ on: on}")
          v-btn.mr-5(color="error" @click.stop="deleteKeyWord" v-on="on" icon)
            v-icon mdi-close
  v-expansion-panel-content
    v-chip-group(v-if="synonyms.length" column)
      v-chip(
        v-for="synonym in synonyms" :key="synonym.id"
        color="info"
        close
        @click:close="deleteSynonym(synonym.id)"
      ) {{synonym.name}}
    p(v-else) еще нет не одной формы этого слова
    v-row.pa-0.ma-0
      v-spacer
      v-btn(@click="dialog = true" color="primary" ) Добавить форму слова

  v-dialog(v-model="dialog" max-width="900")
    v-card(dark)
      v-card-title Добавление формы слова
      v-card-text
        v-text-field(
          v-model="wordName"
          label="Введите форму слова"
        )
      v-card-actions
        v-btn(@click="resetDialogs" color="error") Отмена
        v-spacer
        v-btn.mb-4(@click="createSynonym" color="success") Сохранить
</template>
</template>
<script>
import autoAnswerService from '@/services/API/autoAnswer';

export default {
  name: 'KeyWordPanel',
  props: {
    keyWord: { type: Object, required: true },
  },
  data() {
    return {
      open: false,
      dialog: false,
      loading: true,
      synonyms: [],
      wordName: '',
    };
  },
  watch: {
    open() {
      this.getSynonym();
    },
  },
  methods: {
    resetDialogs() {
      this.dialog = false;
      this.wordName = '';
    },
    async getSynonym() {
      try {
        const response = await autoAnswerService.getSynonym({ 'search[tag_id]': this.keyWord.id });
        this.synonyms = response.data.data;
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async deleteSynonym(id) {
      try {
        await autoAnswerService.deleteSynonym(id);
        this.$toast.success('Успешно удалено');
        this.getSynonym();
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async deleteKeyWord() {
      try {
        await autoAnswerService.deleteKeyWord(this.keyWord.id);
        this.$toast.success('Успешно удалено');
        this.$emit('update');
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async createSynonym() {
      try {
        const response = await autoAnswerService.createSynonym({ name: this.wordName, tag_id: this.keyWord.id });
        this.$toast.success('Успешно созданна');
        this.synonyms.push(response.data.data);
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
      this.resetDialogs();
    },
  },
};
</script>
